<template>
  <v-card>
    <v-card-title>Missed calls</v-card-title>
    <v-data-table :headers="headers" :items="missedCalls">
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn icon color="success">
          <v-icon @click="call(item)"> mdi-phone </v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Reset </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "GuideTable",
  inject: ["theme"],
  data() {
    return {
      headers: [
        { text: "Number", align: "center", value: "number" },
        { text: "Date", align: "center", value: "updated" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  method: {
    call(e) {
      console.log("call -> e", e);
    },
  },
  computed: {
    ...mapGetters({
      missedCalls: "missedCalls/missedCalls",
    }),
  },
};
</script>
